import { render, staticRenderFns } from "./popupaddStudent.vue?vue&type=template&id=65a8a80e&scoped=true&"
import script from "./popupaddStudent.vue?vue&type=script&lang=js&"
export * from "./popupaddStudent.vue?vue&type=script&lang=js&"
import style0 from "./popupaddStudent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./popupaddStudent.vue?vue&type=style&index=1&id=65a8a80e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8a80e",
  null
  
)

export default component.exports